module.exports = __webpack_public_path__ + "static/media/affinitydiagramming.98a93227.jpeg";